import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* keep polling */ }
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("error");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink p-6">
      <div className="max-w-md w-full text-center bg-ink-surface border border-ink rounded-md p-10">
        {status === "checking" && (<><Loader2 className="w-10 h-10 text-gold animate-spin mx-auto mb-6" /><h1 className="text-cream text-2xl font-serif mb-2">Confirming your subscription…</h1><p className="text-cream-muted text-sm">This only takes a moment.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="w-12 h-12 text-green-400 mx-auto mb-6" /><h1 className="text-cream text-3xl font-serif mb-3">You're all set</h1><p className="text-cream-muted text-sm mb-8">Your plan is active. Your guest relations hub is ready to go live.</p><Link to="/dashboard"><Button data-testid="success-continue" className="rounded-full bg-gold text-black hover:bg-[#D6BB96] px-8">Go to dashboard</Button></Link></>)}
        {status === "error" && (<><XCircle className="w-12 h-12 text-red-400 mx-auto mb-6" /><h1 className="text-cream text-2xl font-serif mb-3">Payment not confirmed</h1><p className="text-cream-muted text-sm mb-8">We couldn't confirm your payment. Please try again from billing.</p><Link to="/dashboard/billing"><Button variant="outline" className="rounded-full border-cream/30 text-cream">Back to billing</Button></Link></>)}
      </div>
    </div>
  );
}
